<template>
  <a-modal
      title="上传比赛视频"
      :visible="visible"
      width="600px"
      @ok="handleOk"
      @cancel="handleCancel"
    >
    <div style="margin-bottom:10px;">
      已上传大小：{{ fileSize }}M
      <a-progress :percent="percent" status="active" />
      <input type="file" ref="videoInput" style="display: none;" @change="changeFile">
    </div>
    <p>注：1.每次打开这个窗口都会清除之前的上传记录，若之前已上传过，点击取消即可</p>
    <p>&ensp;&ensp;&ensp;&ensp;2.重新上传将会覆盖之前的视频</p>
    <p v-for="(item, index) in videoList" :key="index">
      视频{{ index + 1 }}：{{ item.name }}
      <a-button icon="cloud-upload" style="float:right;" type="primary" size="small" @click="uploadVideoNum(item.num)">
       点击上传
      </a-button>
      <a-tag style="float:right;" v-if="dataUrl[item.num] || item.video !== null" color="#87d068">上传成功<a-icon type="check" /></a-tag>
      <a-tag style="float:right;" v-else>还未上传！</a-tag>
      <a target="_blank" :href="dataUrl[item.num]" v-if="dataUrl[item.num]">点击查看<a-icon type="search" /></a>
      <a target="_blank" :href="item.video" v-else-if="item.video">点击查看<a-icon type="search" /></a>
    </p>
  </a-modal>
</template>
<script>
require('@comm/utils/qiniu.min.js')
export default {
  name: 'UploadVideo',
  components: {
  },
  data () {
    return {
      upToken: null,
      visible: false,
      fileSize: 0,
      percent: 0,
      index: null,
      combatDetailId: null,
      num: 1,
      videoList: [],
      dataUrl: {}
    }
  },
  methods: {
    changeVideo (combatId, combatDetailId, teamNumber, index) {
      this.dataUrl = {}
      this.fileSize = 0
      this.visible = true
      this.percent = 0
      this.combatId = combatId
      this.combatDetailId = combatDetailId
      this.index = index
      let valData = {
        agencyId: this.$route.query.agencyId,
        teamId: this.$route.query.teamId,
        combatId: combatId,
        combatDetailId: combatDetailId,
        teamNumber: teamNumber,
        cardId: this.$route.query.cardId === undefined ? -1 : this.$route.query.cardId
      }
      this.$api.join.findVideo(valData).then(res => {
        if (res.status === 0) {
          this.videoList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
      console.log(combatId)
      // this.$refs.videoInput.dispatchEvent(new MouseEvent('click'))
    },
    handleOk () {
      this.videoList.forEach(element => {
        if (element.video !== null && !this.dataUrl[element.num]) {
          this.dataUrl[element.num] = element.video
        }
      })
      if (Object.keys(this.dataUrl).length < this.videoList.length) {
        this.$message.error(`你还有视频未上传完成!`)
        return
      }
      let data = {
        data: this.dataUrl,
        combatDetailId: this.combatDetailId,
        index: this.index
      }
      this.$emit('changeDataUrl', data)
      this.handleCancel()
    },
    uploadVideoNum (num) {
      this.num = num
      this.fileSize = 0
      this.percent = 0
      this.$refs.videoInput.dispatchEvent(new MouseEvent('click'))
    },
    handleCancel () {
      this.visible = false
    },
    changeFile (e) {
      let file = e.target.files[0] // 对象，上传的文件
      if (file.size > 50000000) {
        this.$message.error(`文件超过50M，无法上传!`)
        return
      }
      if (file.type !== 'video/mp4') {
        this.$message.error(`请上传mp4格式的视频文件!`)
        return
      }
      let key = Math.floor(Math.random() * 1000000000000) + '.' + file.name.substring(file.name.lastIndexOf('.') + 1) // 文件资源名
      /*
      * config.useCdnDomain: 是否使用 cdn 加速域名，true or false，默认为 false。
      * config.disableStatisticsReport: 是否禁用日志报告，为布尔值，默认为false。
      * config.region: 选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域
      * config.retryCount: 上传自动重试次数（整体重试次数）；默认3次（即上传失败后最多重试两次）；
      * config.concurrentRequestLimit: 分片上传的并发请求量，number，默认为3；
      * config.checkByMD5: 是否开启 MD5 校验，在断点续传时校验分片，默认为 false，不开启。
      */
      let qiniu = global.qiniu
      let config = {
        useCdnDomain: true
      }

      /*
      * fname: string，文件原文件名.
      * params: object，用来放置自定义变量;
      * mimeType: null || array，用来限制上传文件类型，为 null 时表示不对文件类型限制；
      * 限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
      */
      let putExtra = {
        fname: file.name,
        params: {}
      }
      let that = this
      let observe = {
        next (res) {
          console.log('已上传大小，单位为字节：' + res.total.loaded)
          console.log('本次上传的总量控制信息，单位为字节：' + res.total.size)
          console.log('当前上传进度，范围：0～100：' + res.total.percent)
          if ((res.total.loaded / 1000000) > that.fileSize) {
            that.fileSize = res.total.loaded / 1000000
          }
          if (res.total.percent > 0 && parseInt(res.total.percent) > that.percent) {
            that.percent = parseInt(res.total.percent)
          }
        },
        error (err) {
          console.log(err.code)
          console.log(err.message)
          console.log(err.isRequestError)
          console.log(err.reqId)
        },
        complete (res) {
        // 完成后的操作
        // 上传成功以后会返回key 和 hash  key就是文件名了！
          that.dataUrl[that.num] = 'https://static.daoba.com/' + res.key
          that.$forceUpdate()
        }
      }
      // 开始上传  token 需要找后端获取(单独的方法)
      let observable = qiniu.upload(file, key, this.upToken, putExtra, config)
      observable.subscribe(observe)
    }
  },
  mounted () {
    this.$api.join.getUpToken().then(res => {
      if (res.status === 0) {
        this.upToken = res.data.upToken
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/comm/components/join/heaveCompetition/UploadVideo.vue